var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagOfTatarstan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#008000",
    width: 600,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 600,
    height: 20,
    y: 140
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#F00",
    width: 600,
    height: 140,
    y: 160
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfTatarstan);
export default __webpack_public_path__ + "static/media/Flag_of_Tatarstan.d2e656b9e2120558d799f54b012c4d2b.svg";
export { ForwardRef as ReactComponent };